module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "painel"
  }, [_c('div', {
    staticClass: "fechamentos"
  }, [_c('div', {
    staticClass: "cabecalho-fechamentos"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "h2 mb-0 icon-detalhe-fechamentoextra"
  }, [_c('router-link', {
    attrs: {
      "to": "/ExibirFechamentoExtra"
    }
  }, [_c('b-icon-arrow-left-short')], 1)], 1)]), _vm._v(" "), _c('h2', [_vm._v("Fechamento extracontratual n° " + _vm._s(_vm.fechamentoAtual.id))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-borderless",
    attrs: {
      "id": "tabelaControle"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.uf) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.tipo_imovel_servico) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.nome) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.ano_de_referencia) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), (_vm.fechamentoAtual.valor_extra > 0) ? _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.moeda(_vm.fechamentoAtual.valor_extra)) + "\n              ")])]) : _c('td', {
    staticClass: "col-md-9"
  }, [_vm._m(6)])]), _vm._v(" "), (_vm.fechamentoAtual.siglas_extra) ? _c('tr', [_c('td', {
    staticClass: "col-md-12",
    attrs: {
      "nowrap": "",
      "colspan": "2"
    }
  }, [_vm._m(7), _vm._v(" "), (_vm.fechamentoAtual.siglas_extra != '') ? _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('table', {
    staticClass: "table table-borderless table-hover table-sm table-responsive w-100"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.fechamentoAtual.siglas_extra), function(extra) {
    return _c('tr', {
      key: extra.id
    }, [_c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(extra.numero_chamado))]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(extra.sigla))]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(_vm.moeda(extra.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(extra.servico))])])
  }), 0)])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_vm._v(" - ")])])]) : _c('tr', [_vm._m(9), _vm._v(" "), (_vm.fechamentoAtual.predio_id) ? _c('td', [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, _vm._l((_vm.predios), function(item) {
    return _c('div', {
      key: item.sigla,
      staticClass: "siglas_extra"
    }, [_c('b-badge', {
      staticClass: "bdg",
      attrs: {
        "pill": "",
        "variant": "light"
      }
    }, [_vm._v(_vm._s(item.sigla))])], 1)
  }), 0)]) : _c('td', [_vm._m(10)])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), (_vm.fechamentoAtual.arquivo_carga_extra && _vm.fechamentoAtual.arquivo_carga_extra !== ' -- ') ? _c('td', [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.fechamentoAtual.arquivo_carga_extra)
      }
    }
  }, [_vm._v("Download")])])]) : _c('td', [_vm._m(12)])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), (_vm.fechamentoAtual.arquivo_extra && _vm.fechamentoAtual.arquivo_extra !== ' -- ') ? _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.fechamentoAtual.arquivo_extra)
      }
    }
  }, [_vm._v("Download")])])]) : _c('td', {
    staticClass: "col-md-9"
  }, [_vm._m(14)])]), _vm._v(" "), _c('tr', [_vm._m(15), _vm._v(" "), (_vm.fechamentoAtual.comodato_extra > 0) ? _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.moeda(_vm.fechamentoAtual.comodato_extra)) + "\n              ")])]) : _c('td', {
    staticClass: "col-md-9"
  }, [_vm._m(16)])]), _vm._v(" "), (_vm.fechamentoAtual.siglas_comodato_extra) ? _c('tr', [_c('td', {
    staticClass: "col-md-12",
    attrs: {
      "nowrap": "",
      "colspan": "2"
    }
  }, [_vm._m(17), _vm._v(" "), (_vm.fechamentoAtual.siglas_comodato_extra != '') ? _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('table', {
    staticClass: "table table-borderless table-hover table-sm table-responsive w-100"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.fechamentoAtual.siglas_comodato_extra), function(comodato) {
    return _c('tr', {
      key: comodato.id
    }, [_c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(comodato.numero_chamado))]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(comodato.sigla))]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": ""
      }
    }, [_vm._v(_vm._s(_vm.moeda(comodato.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(comodato.servico))])])
  }), 0)])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_vm._v(" - ")])])]) : _c('tr', [_vm._m(19), _vm._v(" "), (_vm.fechamentoAtual.predio_id) ? _c('td', [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, _vm._l((_vm.predios), function(item) {
    return _c('div', {
      key: item.sigla,
      staticClass: "siglas_extra"
    }, [_c('b-badge', {
      staticClass: "bdg",
      attrs: {
        "pill": "",
        "variant": "light"
      }
    }, [_vm._v(_vm._s(item.sigla))])], 1)
  }), 0)]) : _c('td', [_vm._m(20)])]), _vm._v(" "), _c('tr', [_vm._m(21), _vm._v(" "), (_vm.fechamentoAtual.arquivo_carga_comodato && _vm.fechamentoAtual.arquivo_carga_comodato !== ' -- ') ? _c('td', [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.fechamentoAtual.arquivo_carga_comodato)
      }
    }
  }, [_vm._v("Download")])])]) : _c('td', [_vm._m(22)])]), _vm._v(" "), _c('tr', [_vm._m(23), _vm._v(" "), (_vm.fechamentoAtual.arquivo_comodato && _vm.fechamentoAtual.arquivo_comodato !== ' -- ') ? _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('a', {
    staticClass: "downloadArquivo",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadArquivo(_vm.fechamentoAtual.arquivo_comodato)
      }
    }
  }, [_vm._v("Download")])])]) : _c('td', {
    staticClass: "col-md-9"
  }, [_vm._m(24)])]), _vm._v(" "), _c('tr', [_vm._m(25), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.data_envio_fechamento) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(26), _vm._v(" "), _c('td', {
    staticClass: "col-md-9",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.email) + "\n              ")])])]), _vm._v(" "), _c('tr', [_vm._m(27), _vm._v(" "), _c('td', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_vm._v("\n                " + _vm._s(_vm.fechamentoAtual.descricao_extra) + "\n              ")])])])])])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.fechamentoAtual
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('h4', {
    staticClass: "sub-header"
  }, [_vm._v("Dados do Fechamento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Estado:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Contrato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Mês de referência:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Ano de referência:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Valor Oi:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('strong', [_vm._v("Detalhamento Oi:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Número do chamado")]), _vm._v(" "), _c('th', [_vm._v("Sigla")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Serviço")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Siglas Oi:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Arquivo Carga Extra (Oi):")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Arquivo Extracontratual Oi:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Valor Comodato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('strong', [_vm._v("Detalhamento Comodato:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Número do chamado")]), _vm._v(" "), _c('th', [_vm._v("Sigla")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Serviço")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Siglas Comodato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Arquivo Carga Comodato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Arquivo Extracontratual Comodato:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-8"
  }, [_c('span', {
    staticClass: "downloadArquivo"
  }, [_vm._v(" - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Data preenchimento:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3",
    attrs: {
      "nowrap": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Email de quem preencheu:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4"
  }, [_c('strong', [_vm._v("Descrição:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68973dac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aplicacaoFechamentoExtra/DetalhesFechamentoExtra.vue
// module id = 999
// module chunks = 1